import { SelectAllCheckbox as CommonSelectAll } from "@visiblethread/react-components";
import { map } from "lodash";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedRowIds } from "slices/proposalOutline/outlineSlice";
import {
  selectProposalOutlineSections,
  selectSelectedRowIds,
} from "slices/proposalOutline/selectors";

import classes from "./SelectAllCheckbox.module.scss";

const SelectAllCheckbox = () => {
  const selectedRowIds = useSelector(selectSelectedRowIds);
  const sections = useSelector(selectProposalOutlineSections);
  const dispatch = useDispatch();

  const allSectionIds = useMemo(() => map(sections, "id"), [sections]);

  const onCheckAll = () => {
    dispatch(setSelectedRowIds(allSectionIds));
  };

  const onUncheckAll = () => {
    dispatch(setSelectedRowIds([]));
  };

  return (
    <div className={classes["select_all_checkbox"]}>
      <CommonSelectAll
        className="select_all_checkbox"
        selectedItems={selectedRowIds}
        allItems={allSectionIds}
        checkAll={onCheckAll}
        uncheckAll={onUncheckAll}
      />
    </div>
  );
};

export default SelectAllCheckbox;
